<template>

  <div>
    <span id="the-top"></span>
    <a class="button" id="back-to-top" :class="{ 'visible' : visible }" href="#the-top">↑</a>
  </div>


</template>


<script type="text/babel">

  import ScrollMonitor from 'scrollmonitor';

  export default {

    data() {
      return {
        visible: false,
      }
    },

    mounted() {
      let vm = this;
      vm.createWatcher();
    },

    props: {
      path: { type: String, default: '' }
    },

    computed: {},

    methods: {


      createWatcher(){
        let vm = this;
        let top = document.getElementById('the-top');
        var elWatcher = ScrollMonitor.create(top);

        elWatcher.exitViewport(function(){
          vm.setActiveState(true);
        });

        elWatcher.enterViewport(function(){
          vm.setActiveState(false)
        });
      },

      setActiveState(b){
        if(b){ this.visible = true };
        if(!b){ this.visible = false };
      }
    }
  }

</script>
